import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center bg-[#0A0A0A] overflow-hidden pt-20 pb-12 px-4" data-id="element-121">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#1a1a1a] via-[#0A0A0A] to-[#0A0A0A] opacity-50" data-id="element-122"></div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C5A55A]/30 to-transparent" data-id="element-123"></div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative z-10" data-id="element-124">
        {/* Text Content */}
        <motion.div className="lg:col-span-7 flex flex-col justify-center text-center lg:text-left" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-125">
          <h1 className="text-2xl md:text-3xl font-serif leading-tight mb-6 text-[#C5A55A]" data-id="element-126">
            🚨 TU RELACIÓN ESTÁ EN SOS
          </h1>

          {/* Opening lines */}
          <div className="text-lg md:text-xl text-[#FAF7F2]/80 font-light leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0 space-y-5 text-left" data-id="element-127">
            <p data-id="element-128">aunque nadie lo esté diciendo en voz alta.</p>
            <div data-id="element-129">
              <p data-id="element-130">No fue una pelea.</p>
              <p data-id="element-131">No fue una traición.</p>
              <p data-id="element-132">No fue una crisis.</p>
            </div>
            <div data-id="element-133">
              <p data-id="element-134">Fue el silencio.</p>
              <p data-id="element-135">La rutina.</p>
              <p data-id="element-136">El "mañana lo vemos".</p>
            </div>
            <div data-id="element-137">
              <p data-id="element-138">Y cuando el deseo baja…</p>
              <p data-id="element-139">la distancia empieza.</p>
            </div>
          </div>

          {/* Separator */}
          <div className="w-full h-px bg-[#FAF7F2]/20 my-8 max-w-2xl mx-auto lg:mx-0" data-id="element-140"></div>

          {/* Logo - moved above 18 MÉTODOS */}
          <motion.div className="flex justify-center lg:justify-start mb-6" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/dKYFCgZbhFMXzoXJTgVhUs/Logo_18_metodos.jpg" alt="18 Métodos Logo" className="h-36 md:h-48 w-auto object-contain drop-shadow-2xl" loading="eager" decoding="async" data-id="element-142" />
          </motion.div>

          {/* 18 MÉTODOS block */}
          <motion.div className="max-w-2xl mx-auto lg:mx-0 text-left mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} data-id="element-143">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#C5A55A] mb-4" data-id="element-144">
              18 MÉTODOS
            </h2>
            <p className="text-xl md:text-2xl text-[#FAF7F2] font-light mb-1" data-id="element-145">
              Una intervención íntima de 90 minutos
            </p>
            <p className="text-xl md:text-2xl text-[#FAF7F2]/80 font-light mb-6" data-id="element-146">
              para reactivar el deseo antes de que sea tarde.
            </p>
            <p className="text-lg text-[#C5A55A] font-medium mb-8" data-id="element-147">
              Recupera tensión. Rescata conexión. Vuelve a sentir atracción
              real.
            </p>

            {/* Badges */}
            <div className="flex flex-wrap gap-4 mb-8" data-id="element-148">
              <span className="bg-[#1a1a1a] border border-[#C5A55A]/30 text-[#FAF7F2]/90 px-4 py-2 rounded-sm text-sm" data-id="element-149">
                🎥 Clase grabada
              </span>
              <span className="bg-[#1a1a1a] border border-[#C5A55A]/30 text-[#FAF7F2]/90 px-4 py-2 rounded-sm text-sm" data-id="element-150">
                ⚡ Acceso inmediato
              </span>
              <span className="bg-[#1a1a1a] border border-[#C5A55A]/30 text-[#FAF7F2]/90 px-4 py-2 rounded-sm text-sm" data-id="element-151">
                💰 Hoy $10
              </span>
            </div>

            {/* CTA */}
            <motion.a href="https://pay.hotmart.com/O104329024S?off=5fgsnhcn&checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center gap-3 bg-[#B91C1C] hover:bg-[#991b1b] text-white text-lg md:text-xl font-bold py-5 px-10 rounded-sm shadow-[0_0_30px_rgba(185,28,28,0.5)] hover:shadow-[0_0_50px_rgba(185,28,28,0.7)] transition-all duration-300 group w-full md:w-auto text-center" data-id="element-152">
              QUIERO RESCATAR MI RELACIÓN AHORA
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-153" />
            </motion.a>
          </motion.div>
        </motion.div>

        {/* Image Content */}
        <motion.div className="lg:col-span-5 relative" initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} data-id="element-154">
          <div className="relative rounded-lg overflow-hidden border border-[#C5A55A]/30 shadow-[0_0_40px_rgba(197,165,90,0.1)]" data-id="element-155">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-40 z-10" data-id="element-156"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2mkggpq2zWoticVMYNe24j/Foto_2_de_la_DOC_para_pagina_(1).jpg" alt="Beatriz - Inmersión Pareja" className="w-full h-auto object-cover" loading="eager" fetchPriority="high" decoding="async" data-id="element-157" />
          </div>
          <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#C5A55A]/20 -z-10 rounded-lg" data-id="element-158"></div>
        </motion.div>
      </div>
    </section>;
}